/**
 * Defined in:
 *   {@link file://./../../../dxos/echo/query.proto}
 */
export var QueryReactivity;
(function (QueryReactivity) {
    QueryReactivity[QueryReactivity["ONE_SHOT"] = 0] = "ONE_SHOT";
    QueryReactivity[QueryReactivity["REACTIVE"] = 1] = "REACTIVE";
})(QueryReactivity || (QueryReactivity = {}));
//# sourceMappingURL=query.js.map